@defer (when block) {
  <div class="cms-item-block" [class.is-editing]="isEditing" (click)="wasClicked($event)" [ngClass]="{ 'align-right': block.align === 'right', 'align-center': block.align === 'center' }">
    @switch (block.type) {
      @case ('text') {
        <div class="body">
          <span>{{ block.body }}</span>
        </div>
      }
      @case ('image') {
        <div class="image">
          @if (block.reference) {
            <div>
              @if (block.reference.substring(0, 4) !== 'http') {
                <img class="img-responsive" src="https://s3.eu-west-2.amazonaws.com/4d-documents/{{ block.reference }}" />
              } @else {
                <img class="img-responsive" src="{{ block.reference }}" />
              }
            </div>
          }
        </div>
      }
      @case ('link') {
        <div class="link">
          <span>
            <a target="_blank" href="{{ block.reference }}"> <i class="fa fa-external-link"></i> {{ block.body || 'link' }}</a>
          </span>
        </div>
      }
    }
    <div class="actions">
      <i class="fa fa-angle-up" (click)="wasMoved('up')"></i>
      <i class="fa fa-angle-down" (click)="wasMoved('down')"></i>
      <i class="fa fa-trash" (click)="wasTrashed($event)"></i>
    </div>
  </div>
} @placeholder {
  <i class="fa fa-refresh fa-spin"></i>
}
